<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

// Icons
import whatsappDesktop from '@i/whatsapp-desktop.svg';
import whatsappMobile from '@i/whatsapp-mobile.svg';

import Icon from '@/Components/Images/Icon.vue';

const whatsappPhoneNumber = computed(() => usePage().props.template_options.global.whatsapp_phone_number);
</script>

<template>
    <div class="fixed bottom-0 right-5 z-50">
        <a
            :href="`https://wa.me/${whatsappPhoneNumber}`"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            class="bg-green-whatsapp hover:bg-green-whatsapp-darker pointer-events-auto rounded-2xl p-4 duration-300"
        >
            <Icon
                class="md:hidden"
                :icon="whatsappMobile"
                :alt="'Whatsapp icon'"
            />
            <Icon
                class="hidden md:block"
                :icon="whatsappDesktop"
                :alt="'Whatsapp icon'"
            />
        </a>
    </div>
</template>
